/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  VotingGovernor,
  VotingGovernorInterface,
} from "../VotingGovernor";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "contract ERC20Votes",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_initialVotingDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialVotingPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialProposalThreshold",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialVoteQuorumFraction",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "proposer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "signatures",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldProposalThreshold",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "ProposalThresholdSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldQuorumNumerator",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "QuorumNumeratorUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "weight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "VoteCast",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingDelay",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "VotingDelaySet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingPeriod",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "VotingPeriodSet",
    type: "event",
  },
  {
    inputs: [],
    name: "BALLOT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "COUNTING_MODE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
    ],
    name: "castVote",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "castVoteBySig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "castVoteWithReason",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllProposals",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "proposalId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "proposer",
            type: "address",
          },
          {
            internalType: "address[]",
            name: "targets",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "values",
            type: "uint256[]",
          },
          {
            internalType: "string[]",
            name: "signatures",
            type: "string[]",
          },
          {
            internalType: "bytes[]",
            name: "calldatas",
            type: "bytes[]",
          },
          {
            internalType: "uint256",
            name: "startBlock",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endBlock",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "description",
            type: "string",
          },
        ],
        internalType: "struct VotingGovernor.Proposal[]",
        name: "allProposals",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasVoted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "hashProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "indexForProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalDeadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "againstVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "forVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "abstainVotes",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "proposals",
    outputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "proposer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "startBlock",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endBlock",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "propose",
    outputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "quorum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumDenominator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumNumerator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "setProposalThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "setVotingDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "setVotingPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "state",
    outputs: [
      {
        internalType: "enum IGovernor.ProposalState",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract ERC20Votes",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "updateQuorumNumerator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type VotingGovernorConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VotingGovernorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VotingGovernor__factory extends ContractFactory {
  constructor(...args: VotingGovernorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _name: string,
    _token: string,
    _initialVotingDelay: BigNumberish,
    _initialVotingPeriod: BigNumberish,
    _initialProposalThreshold: BigNumberish,
    _initialVoteQuorumFraction: BigNumberish,
    _trustedForwarder: string,
    _uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<VotingGovernor> {
    return super.deploy(
      _name,
      _token,
      _initialVotingDelay,
      _initialVotingPeriod,
      _initialProposalThreshold,
      _initialVoteQuorumFraction,
      _trustedForwarder,
      _uri,
      overrides || {}
    ) as Promise<VotingGovernor>;
  }
  getDeployTransaction(
    _name: string,
    _token: string,
    _initialVotingDelay: BigNumberish,
    _initialVotingPeriod: BigNumberish,
    _initialProposalThreshold: BigNumberish,
    _initialVoteQuorumFraction: BigNumberish,
    _trustedForwarder: string,
    _uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _name,
      _token,
      _initialVotingDelay,
      _initialVotingPeriod,
      _initialProposalThreshold,
      _initialVoteQuorumFraction,
      _trustedForwarder,
      _uri,
      overrides || {}
    );
  }
  attach(address: string): VotingGovernor {
    return super.attach(address) as VotingGovernor;
  }
  connect(signer: Signer): VotingGovernor__factory {
    return super.connect(signer) as VotingGovernor__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VotingGovernorInterface {
    return new utils.Interface(_abi) as VotingGovernorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VotingGovernor {
    return new Contract(address, _abi, signerOrProvider) as VotingGovernor;
  }
}
